import React from 'react';
import { ErrorMessage, FastField } from 'formik';
import Proptypes from 'prop-types';
import { formErrorMessage } from './FormErrorMessage';
import AsyncMap from '../GoogleMap/AsyncMap';

const FormikAsyncMap = ({
  name,
  editProfileComp = false,
  ...props
}) => (
  <FastField name={name}>
    {({ field, form: { touched, errors, submitCount, setFieldValue } }) => (
      <>
        <AsyncMap
          setFieldValue={setFieldValue}
          editProfileComp={editProfileComp}
          handleChange={(autoComplete) => {
            if (autoComplete !== null) {
              const place = autoComplete?.getPlace
                ? autoComplete.getPlace()
                : null;
              const address = {};
              const addressComponents = place?.address_components;

              address.city =
                addressComponents?.find((component) =>
                  component?.types?.includes('locality'),
                )?.long_name || '';
              address.zipCode =
                addressComponents?.find((component) =>
                  component?.types?.includes('postal_code'),
                )?.long_name || '';

              const state = addressComponents?.find((component) =>
                component?.types?.includes('administrative_area_level_1'),
              );
              address.state = state?.long_name || '';
              address.country =
                addressComponents?.find((component) =>
                  component?.types?.includes('country'),
                )?.long_name || '';
              address.address = place.formatted_address || '';
              address.latitude = place?.geometry?.location?.lat
                ? place.geometry.location.lat()
                : '';
              address.longitude = place?.geometry?.location?.lng
                ? place.geometry.location.lng()
                : '';
              for (const key in address) {
                setFieldValue(key, address[key], true);
              }
              setFieldValue('address', address.address);

              // google Map location Url
              setFieldValue('googlePlaceId', place?.place_id);
              setFieldValue('googleMapLocationUrl', place?.url);

              setFieldValue(
                'address2',
                genrateAddressStringForFrontend(
                  place?.name,
                  address.city,
                  state?.long_name,
                  state?.short_name,
                  address.zipCode,
                ),
              );
            } else {
            }
          }}
          isinvalid={submitCount && touched[field.name] && errors[field.name]}
          address={field.value || ''}
          {...props}
        />
        {submitCount > 0 && (
          <ErrorMessage name={field.name} render={formErrorMessage} />
        )}
      </>
    )}
  </FastField>
);

FormikAsyncMap.propTypes = {
  name: Proptypes.string.isRequired,
  placeholder: Proptypes.string,
};
export default React.memo(FormikAsyncMap);

const genrateAddressStringForFrontend = (
  streedAdd,
  city,
  state,
  stateShortName,
  postalCode,
) => {
  let address = '';
  if (streedAdd) address += streedAdd;
  if (city) address += ',/n' + city + ', ';
  if (stateShortName && streedAdd !== state) address += stateShortName;
  if (postalCode) address += ' ' + postalCode;
  return address;
};
